import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
import { MfaFlow } from '@accountFederation/modules/securityCheck/faceId/mfaFlows';

type FaceIdEventLogger = (label: string) => void;
const noLogger: FaceIdEventLogger = (_) => {};

const loggerMap: Record<MfaFlow, FaceIdEventLogger> = {
    [MfaFlow.Withdrawal]: logWithdrawalFaceId,
    [MfaFlow.Login]: noLogger,
    [MfaFlow.CloseAccount]: noLogger,
    [MfaFlow.ReopenAccount]: noLogger,
    [MfaFlow.ResetPassword]: noLogger,
    [MfaFlow.UpdatePassword]: noLogger,
    [MfaFlow.BankAccountManagement]: noLogger,
    [MfaFlow.UpdatePhoneNumber]: noLogger,
};

export function getFaceIdLogger(flowName?: MfaFlow): FaceIdEventLogger {
    return flowName ? loggerMap[flowName] : noLogger;
}

function logWithdrawalFaceId(label: string): void {
    AnalyticsSDK.getInstance().log('Withdrawal_faceId', {
        eventAction: 'open_face_id',
        eventLabel: label,
        timestamp: new Date().toISOString(),
    });
}
